module.exports = __webpack_public_path__ + "img/国防科技大学系统工程学院.92a90f4a.png";